var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 0C3.26042 0 0 3.26042 0 7.29167C0 12.7604 7.29167 20.8333 7.29167 20.8333C7.29167 20.8333 14.5833 12.7604 14.5833 7.29167C14.5833 3.26042 11.3229 0 7.29167 0ZM7.29167 9.89583C6.601 9.89583 5.93862 9.62147 5.45024 9.13309C4.96187 8.64471 4.6875 7.98233 4.6875 7.29167C4.6875 6.601 4.96187 5.93862 5.45024 5.45024C5.93862 4.96187 6.601 4.6875 7.29167 4.6875C7.98233 4.6875 8.64471 4.96187 9.13309 5.45024C9.62147 5.93862 9.89583 6.601 9.89583 7.29167C9.89583 7.98233 9.62147 8.64471 9.13309 9.13309C8.64471 9.62147 7.98233 9.89583 7.29167 9.89583V9.89583Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.58fa29751c5809cf08604c23fc517498.svg";
export { ForwardRef as ReactComponent };